import * as React from 'react'
import {connect} from 'react-redux'
import Layout from './Layouts'
import PauseResume from './PauseResume'
import '../assets/scss/Base/base.scss'

const App = (props:any) => {
    return (
      <div>
            <PauseResume />
            <Layout />
      </div>
    )
}

export default connect(null)(App)
